import $ from 'jquery';
import ClipboardJS from 'clipboard';
import 'sharer.js';

const clipBoard = new ClipboardJS('.share-button--copy');
clipBoard.on('success', function (e) {
    const $this = $(e.trigger);

    $this.addClass('share-button--copy-success');

    setTimeout(function () {
        $this.removeClass('share-button--copy-success');
    }, 3000);
});

$('.share-button--toggle').on('click', function () {
    const $this = $(this);

    $this
        .parent()
        .find('.share-buttons__more')
        .toggleClass('share-buttons__more--active');

    $this
        .find('.share-button__toggle-icon')
        .toggleClass('onsc-icons-share onsc-icons-close');
});

function launchPrintAction() {
    $('.picto-print').click(function () {
        location.hash.replace('#', '');
        printDiv($(this).data('id'));
    });
}

function removeElement(id) {
    var elem = document.getElementById(id);
    if (elem) {
        return elem.parentElement.removeChild(elem);
    }
    else {
        return false;
    }
}

//fonction pour imprimer qu'une partie d'une page web
function printDiv(divName) {
    removeElement('previous'); //suppression du btn retourner a la page entiere s'il existe car on le recree
    var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;

    document.body.innerHTML = '<div id="' + divName + '" class="print-mode container" ><div class="max-720 m-auto"><div class="container noprint mt-4" id="return-full-page"><div class="row"><div class="navigation col-12"><nav><div class="previous"><a href="' + window.location.href.toString() + '" class="prev text-uppercase btn">Retourner à la page</a></div></nav></div></div></div>' + printContents + '</div></div>';

    setTimeout(function () {
        window.print();
        launchPrintAction();
        // document.body.innerHTML = originalContents;
    }, 400);
}
$(document).ready(function ($){
    launchPrintAction();
});
